import { request } from "../libs";

function updateUser({_key, user}) {
	return request(
		`/server/users/${_key}`,
		{
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(user)
		}
	)
		.then(res => res.json());
}

export default updateUser;



// WEBPACK FOOTER //
// ./src/api/update-user.js